import React, {FunctionComponent, PropsWithChildren, useEffect} from 'react';

// When we change the page, we would like to see the top of the page...
// cf. https://reacttraining.com/react-router/web/guides/scroll-restoration
export const ScrollToTop: FunctionComponent<PropsWithChildren> = ({ children}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <>{children}</>;
};
